/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import PropTypes from 'prop-types';
import { createContext } from 'react';

/**
 * The Funnelback context
 * @export
 */
const FunnelbackContext = createContext({
    isFetching: false,
    bestBets: [],
    results: [],
    facets: [],
    fetchResults: () => {},
    onKeyUp: () => {},
    onFocus: () => {},
    defaultValue: '',
    error: null,
    collection: '',
    queryString: '',
    resultsSummary: {
        totalMatching: 0,
        partiallyMatching: 0,
        collapsed: 0,
        currStart: 0,
        currEnd: 0,
        query: '',
    },
    qsups: [],
});

FunnelbackContext.Provider.propTypes = {
    value: PropTypes.shape({
        isFetching: PropTypes.bool,
        bestBets: PropTypes.arrayOf(
            PropTypes.shape({
                titleHtml: PropTypes.string,
                displayUrl: PropTypes.string,
                linkUrl: PropTypes.string,
                descriptionHtml: PropTypes.string,
                messageHtml: PropTypes.string,
                userDisplayMode: PropTypes.string,
            })
        ),
        results: PropTypes.arrayOf(
            PropTypes.shape({
                clickTrackingUrl: PropTypes.string,
                liveUrl: PropTypes.string,
                displayUrl: PropTypes.string,
                indexUrl: PropTypes.string,
                summary: PropTypes.string,
                title: PropTypes.string,
                date: PropTypes.number,
            })
        ),
        facets: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string,
                unselectAllUrl: PropTypes.string,
                selectionType: PropTypes.string,
                constraintJoin: PropTypes.string,
                facetValues: PropTypes.string,
                guessedDisplayType: PropTypes.string,
                allValues: PropTypes.arrayOf(
                    PropTypes.shape({
                        data: PropTypes.string,
                        label: PropTypes.string,
                        count: PropTypes.number,
                        selected: PropTypes.bool,
                        toggleUrl: PropTypes.string,
                    })
                ),
                selectedValues: PropTypes.arrayOf(
                    PropTypes.shape({
                        data: PropTypes.string,
                        label: PropTypes.string,
                        count: PropTypes.number,
                        selected: PropTypes.bool,
                        toggleUrl: PropTypes.string,
                    })
                ),
                selected: PropTypes.bool,
            })
        ),
        fetchResults: PropTypes.func,
        onKeyUp: PropTypes.func,
        onFocus: PropTypes.func,
        defaultValue: PropTypes.string,
        error: PropTypes.string,
        collection: PropTypes.string,
        queryString: PropTypes.string,
        resultsSummary: PropTypes.shape({
            totalMatching: PropTypes.number,
            partiallyMatching: PropTypes.number,
            collapsed: PropTypes.number,
            currStart: PropTypes.number,
            currEnd: PropTypes.number,
            query: PropTypes.string,
        }),
    }),
    qsups: PropTypes.arrayOf(
        PropTypes.shape({
            src: PropTypes.string,
            query: PropTypes.string,
        })
    ),
};

export default FunnelbackContext;
